/**
 * UGC video carousel — hover-to-play (desktop), in-view autoplay (touch/mobile).
 */
(function () {
  'use strict';

  var VISIBILITY_THRESHOLD = 0.55;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function prefersHoverPlay() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function setPlaying(card, playing) {
    if (!card) return;
    card.classList.toggle('is-playing', playing);
  }

  function pauseVideo(video) {
    if (!video) return;
    video.pause();
    try {
      video.currentTime = 0;
    } catch (err) { /* ignore */ }
  }

  function playVideo(video) {
    if (!video) return;
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () { /* autoplay blocked */ });
    }
  }

  function initCarousel(root) {
    if (root.dataset.ugcInit === '1') return;
    root.dataset.ugcInit = '1';

    var track = root.querySelector('[data-ugc-track]');
    if (!track) return;

    var cards = root.querySelectorAll('[data-ugc-card]');
    var prevBtn = root.querySelector('[data-ugc-prev]');
    var nextBtn = root.querySelector('[data-ugc-next]');
    var observers = [];

    function scrollByCard(direction) {
      var card = track.querySelector('[data-ugc-card]');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      var amount = (card.offsetWidth + gap) * direction;
      track.scrollBy({ left: amount, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByCard(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByCard(1);
      });
    }

    if (prefersReducedMotion()) {
      for (var r = 0; r < cards.length; r++) {
        (function (card) {
          var video = card.querySelector('video');
          if (!video) return;
          card.addEventListener('click', function () {
            if (video.paused) {
              playVideo(video);
              setPlaying(card, true);
            } else {
              pauseVideo(video);
              setPlaying(card, false);
            }
          });
        })(cards[r]);
      }
      return;
    }

    if (prefersHoverPlay()) {
      for (var i = 0; i < cards.length; i++) {
        (function (card) {
          var video = card.querySelector('video');
          if (!video) return;

          card.addEventListener('mouseenter', function () {
            playVideo(video);
            setPlaying(card, true);
          });
          card.addEventListener('mouseleave', function () {
            pauseVideo(video);
            setPlaying(card, false);
          });
          card.addEventListener('focusin', function () {
            playVideo(video);
            setPlaying(card, true);
          });
          card.addEventListener('focusout', function () {
            pauseVideo(video);
            setPlaying(card, false);
          });
        })(cards[i]);
      }
      return;
    }

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        for (var j = 0; j < entries.length; j++) {
          var entry = entries[j];
          var cardEl = entry.target.closest('[data-ugc-card]');
          var vid = entry.target;
          if (!cardEl || vid.tagName !== 'VIDEO') continue;

          if (entry.isIntersecting && entry.intersectionRatio >= VISIBILITY_THRESHOLD) {
            playVideo(vid);
            setPlaying(cardEl, true);
          } else {
            pauseVideo(vid);
            setPlaying(cardEl, false);
          }
        }
      },
      { root: track, threshold: [0, VISIBILITY_THRESHOLD, 1] }
    );

    observers.push(observer);

    for (var k = 0; k < cards.length; k++) {
      var v = cards[k].querySelector('video');
      if (v) observer.observe(v);
    }
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-ugc-carousel]');
    for (var i = 0; i < roots.length; i++) {
      initCarousel(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) boot(event.target);
  });
})();
